import { render, staticRenderFns } from "./DepotAddModifyTyre.vue?vue&type=template&id=b187bf90&scoped=true"
import script from "./DepotAddModifyTyre.vue?vue&type=script&lang=js"
export * from "./DepotAddModifyTyre.vue?vue&type=script&lang=js"
import style0 from "./DepotAddModifyTyre.vue?vue&type=style&index=0&id=b187bf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b187bf90",
  null
  
)

export default component.exports